/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ImportRunResponse } from '../api-models';
// @ts-ignore
import { ImportRunRowsResponse } from '../api-models';
// @ts-ignore
import { ImportSetupResponse } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
/**
 * ImportV2Api - axios parameter creator
 * @export
 */
export const ImportV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary The facility\'s imports, newest first.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportHistoryGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/tools/import/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancels a queued or running import; a running one stops after the row in flight, and the rows it imported are still recalculated.
         * @param {string} importRunId The run.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportImportRunIdDelete: async (importRunId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importRunId' is not null or undefined
            assertParamExists('apiV2ToolsImportImportRunIdDelete', 'importRunId', importRunId)
            const localVarPath = `/api/v2/tools/import/{importRunId}`
                .replace(`{${"importRunId"}}`, encodeURIComponent(String(importRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads the file as it was uploaded.
         * @param {string} importRunId The run.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportImportRunIdFileGet: async (importRunId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importRunId' is not null or undefined
            assertParamExists('apiV2ToolsImportImportRunIdFileGet', 'importRunId', importRunId)
            const localVarPath = `/api/v2/tools/import/{importRunId}/file`
                .replace(`{${"importRunId"}}`, encodeURIComponent(String(importRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The run\'s state and counts, for polling.
         * @param {string} importRunId The run.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportImportRunIdGet: async (importRunId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importRunId' is not null or undefined
            assertParamExists('apiV2ToolsImportImportRunIdGet', 'importRunId', importRunId)
            const localVarPath = `/api/v2/tools/import/{importRunId}`
                .replace(`{${"importRunId"}}`, encodeURIComponent(String(importRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads the run\'s log as CSV, undo results included.
         * @param {string} importRunId The run.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportImportRunIdLogGet: async (importRunId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importRunId' is not null or undefined
            assertParamExists('apiV2ToolsImportImportRunIdLogGet', 'importRunId', importRunId)
            const localVarPath = `/api/v2/tools/import/{importRunId}/log`
                .replace(`{${"importRunId"}}`, encodeURIComponent(String(importRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary A page of the run\'s log.
         * @param {string} importRunId The run.
         * @param {string} [outcome] Only rows with this outcome: Info, Imported, ImportedWithWarnings, Skipped or Failed.
         * @param {number} [page] 1-based page.
         * @param {number} [pageSize] Rows per page, at most 500.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportImportRunIdRowsGet: async (importRunId: string, outcome?: string, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importRunId' is not null or undefined
            assertParamExists('apiV2ToolsImportImportRunIdRowsGet', 'importRunId', importRunId)
            const localVarPath = `/api/v2/tools/import/{importRunId}/rows`
                .replace(`{${"importRunId"}}`, encodeURIComponent(String(importRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (outcome !== undefined) {
                localVarQueryParameter['outcome'] = outcome;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Undoes an import: what it added is deleted (soft delete) and what it changed is put back, row  by row. A row changed since, open on another user\'s screen, or in a pay period the caller may  not edit is left and listed in the log.
         * @param {string} importRunId The run.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportImportRunIdUndoPost: async (importRunId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importRunId' is not null or undefined
            assertParamExists('apiV2ToolsImportImportRunIdUndoPost', 'importRunId', importRunId)
            const localVarPath = `/api/v2/tools/import/{importRunId}/undo`
                .replace(`{${"importRunId"}}`, encodeURIComponent(String(importRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads a workbook (.xlsx, .xls or .csv) and queues its import. Each sheet is imported by the  type its file or sheet name selects, as in LegacyApp.
         * @param {File} [file] The workbook.
         * @param {string} [effectiveDate] 
         * @param {boolean} [addEmployeeIfNotFound] 
         * @param {boolean} [onlyUpdateEmptyFields] 
         * @param {number} [companyLaborLevelId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportPost: async (file?: File, effectiveDate?: string, addEmployeeIfNotFound?: boolean, onlyUpdateEmptyFields?: boolean, companyLaborLevelId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/tools/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (effectiveDate !== undefined) { 
                localVarFormParams.append('EffectiveDate', effectiveDate as any);
            }
    
            if (addEmployeeIfNotFound !== undefined) { 
                localVarFormParams.append('AddEmployeeIfNotFound', addEmployeeIfNotFound as any);
            }
    
            if (onlyUpdateEmptyFields !== undefined) { 
                localVarFormParams.append('OnlyUpdateEmptyFields', onlyUpdateEmptyFields as any);
            }
    
            if (companyLaborLevelId !== undefined) { 
                localVarFormParams.append('CompanyLaborLevelId', companyLaborLevelId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Options defaults, the company filter, the run in flight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportSetupGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/tools/import/setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImportV2Api - functional programming interface
 * @export
 */
export const ImportV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImportV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary The facility\'s imports, newest first.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsImportHistoryGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ImportRunResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsImportHistoryGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancels a queued or running import; a running one stops after the row in flight, and the rows it imported are still recalculated.
         * @param {string} importRunId The run.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsImportImportRunIdDelete(importRunId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsImportImportRunIdDelete(importRunId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Downloads the file as it was uploaded.
         * @param {string} importRunId The run.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsImportImportRunIdFileGet(importRunId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsImportImportRunIdFileGet(importRunId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary The run\'s state and counts, for polling.
         * @param {string} importRunId The run.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsImportImportRunIdGet(importRunId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsImportImportRunIdGet(importRunId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Downloads the run\'s log as CSV, undo results included.
         * @param {string} importRunId The run.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsImportImportRunIdLogGet(importRunId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsImportImportRunIdLogGet(importRunId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary A page of the run\'s log.
         * @param {string} importRunId The run.
         * @param {string} [outcome] Only rows with this outcome: Info, Imported, ImportedWithWarnings, Skipped or Failed.
         * @param {number} [page] 1-based page.
         * @param {number} [pageSize] Rows per page, at most 500.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsImportImportRunIdRowsGet(importRunId: string, outcome?: string, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportRunRowsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsImportImportRunIdRowsGet(importRunId, outcome, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Undoes an import: what it added is deleted (soft delete) and what it changed is put back, row  by row. A row changed since, open on another user\'s screen, or in a pay period the caller may  not edit is left and listed in the log.
         * @param {string} importRunId The run.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsImportImportRunIdUndoPost(importRunId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsImportImportRunIdUndoPost(importRunId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Uploads a workbook (.xlsx, .xls or .csv) and queues its import. Each sheet is imported by the  type its file or sheet name selects, as in LegacyApp.
         * @param {File} [file] The workbook.
         * @param {string} [effectiveDate] 
         * @param {boolean} [addEmployeeIfNotFound] 
         * @param {boolean} [onlyUpdateEmptyFields] 
         * @param {number} [companyLaborLevelId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsImportPost(file?: File, effectiveDate?: string, addEmployeeIfNotFound?: boolean, onlyUpdateEmptyFields?: boolean, companyLaborLevelId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsImportPost(file, effectiveDate, addEmployeeIfNotFound, onlyUpdateEmptyFields, companyLaborLevelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Options defaults, the company filter, the run in flight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ToolsImportSetupGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportSetupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ToolsImportSetupGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ImportV2Api - factory interface
 * @export
 */
export const ImportV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImportV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary The facility\'s imports, newest first.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportHistoryGet(options?: AxiosRequestConfig): AxiosPromise<Array<ImportRunResponse>> {
            return localVarFp.apiV2ToolsImportHistoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancels a queued or running import; a running one stops after the row in flight, and the rows it imported are still recalculated.
         * @param {ImportV2ApiApiV2ToolsImportImportRunIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportImportRunIdDelete(requestParameters: ImportV2ApiApiV2ToolsImportImportRunIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<ImportRunResponse> {
            return localVarFp.apiV2ToolsImportImportRunIdDelete(requestParameters.importRunId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads the file as it was uploaded.
         * @param {ImportV2ApiApiV2ToolsImportImportRunIdFileGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportImportRunIdFileGet(requestParameters: ImportV2ApiApiV2ToolsImportImportRunIdFileGetRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV2ToolsImportImportRunIdFileGet(requestParameters.importRunId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The run\'s state and counts, for polling.
         * @param {ImportV2ApiApiV2ToolsImportImportRunIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportImportRunIdGet(requestParameters: ImportV2ApiApiV2ToolsImportImportRunIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<ImportRunResponse> {
            return localVarFp.apiV2ToolsImportImportRunIdGet(requestParameters.importRunId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads the run\'s log as CSV, undo results included.
         * @param {ImportV2ApiApiV2ToolsImportImportRunIdLogGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportImportRunIdLogGet(requestParameters: ImportV2ApiApiV2ToolsImportImportRunIdLogGetRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV2ToolsImportImportRunIdLogGet(requestParameters.importRunId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary A page of the run\'s log.
         * @param {ImportV2ApiApiV2ToolsImportImportRunIdRowsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportImportRunIdRowsGet(requestParameters: ImportV2ApiApiV2ToolsImportImportRunIdRowsGetRequest, options?: AxiosRequestConfig): AxiosPromise<ImportRunRowsResponse> {
            return localVarFp.apiV2ToolsImportImportRunIdRowsGet(requestParameters.importRunId, requestParameters.outcome, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Undoes an import: what it added is deleted (soft delete) and what it changed is put back, row  by row. A row changed since, open on another user\'s screen, or in a pay period the caller may  not edit is left and listed in the log.
         * @param {ImportV2ApiApiV2ToolsImportImportRunIdUndoPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportImportRunIdUndoPost(requestParameters: ImportV2ApiApiV2ToolsImportImportRunIdUndoPostRequest, options?: AxiosRequestConfig): AxiosPromise<ImportRunResponse> {
            return localVarFp.apiV2ToolsImportImportRunIdUndoPost(requestParameters.importRunId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads a workbook (.xlsx, .xls or .csv) and queues its import. Each sheet is imported by the  type its file or sheet name selects, as in LegacyApp.
         * @param {ImportV2ApiApiV2ToolsImportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportPost(requestParameters: ImportV2ApiApiV2ToolsImportPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ImportRunResponse> {
            return localVarFp.apiV2ToolsImportPost(requestParameters.file, requestParameters.effectiveDate, requestParameters.addEmployeeIfNotFound, requestParameters.onlyUpdateEmptyFields, requestParameters.companyLaborLevelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Options defaults, the company filter, the run in flight.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ToolsImportSetupGet(options?: AxiosRequestConfig): AxiosPromise<ImportSetupResponse> {
            return localVarFp.apiV2ToolsImportSetupGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2ToolsImportImportRunIdDelete operation in ImportV2Api.
 * @export
 * @interface ImportV2ApiApiV2ToolsImportImportRunIdDeleteRequest
 */
export interface ImportV2ApiApiV2ToolsImportImportRunIdDeleteRequest {
    /**
     * The run.
     * @type {string}
     * @memberof ImportV2ApiApiV2ToolsImportImportRunIdDelete
     */
    readonly importRunId: string
}

/**
 * Request parameters for apiV2ToolsImportImportRunIdFileGet operation in ImportV2Api.
 * @export
 * @interface ImportV2ApiApiV2ToolsImportImportRunIdFileGetRequest
 */
export interface ImportV2ApiApiV2ToolsImportImportRunIdFileGetRequest {
    /**
     * The run.
     * @type {string}
     * @memberof ImportV2ApiApiV2ToolsImportImportRunIdFileGet
     */
    readonly importRunId: string
}

/**
 * Request parameters for apiV2ToolsImportImportRunIdGet operation in ImportV2Api.
 * @export
 * @interface ImportV2ApiApiV2ToolsImportImportRunIdGetRequest
 */
export interface ImportV2ApiApiV2ToolsImportImportRunIdGetRequest {
    /**
     * The run.
     * @type {string}
     * @memberof ImportV2ApiApiV2ToolsImportImportRunIdGet
     */
    readonly importRunId: string
}

/**
 * Request parameters for apiV2ToolsImportImportRunIdLogGet operation in ImportV2Api.
 * @export
 * @interface ImportV2ApiApiV2ToolsImportImportRunIdLogGetRequest
 */
export interface ImportV2ApiApiV2ToolsImportImportRunIdLogGetRequest {
    /**
     * The run.
     * @type {string}
     * @memberof ImportV2ApiApiV2ToolsImportImportRunIdLogGet
     */
    readonly importRunId: string
}

/**
 * Request parameters for apiV2ToolsImportImportRunIdRowsGet operation in ImportV2Api.
 * @export
 * @interface ImportV2ApiApiV2ToolsImportImportRunIdRowsGetRequest
 */
export interface ImportV2ApiApiV2ToolsImportImportRunIdRowsGetRequest {
    /**
     * The run.
     * @type {string}
     * @memberof ImportV2ApiApiV2ToolsImportImportRunIdRowsGet
     */
    readonly importRunId: string

    /**
     * Only rows with this outcome: Info, Imported, ImportedWithWarnings, Skipped or Failed.
     * @type {string}
     * @memberof ImportV2ApiApiV2ToolsImportImportRunIdRowsGet
     */
    readonly outcome?: string

    /**
     * 1-based page.
     * @type {number}
     * @memberof ImportV2ApiApiV2ToolsImportImportRunIdRowsGet
     */
    readonly page?: number

    /**
     * Rows per page, at most 500.
     * @type {number}
     * @memberof ImportV2ApiApiV2ToolsImportImportRunIdRowsGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiV2ToolsImportImportRunIdUndoPost operation in ImportV2Api.
 * @export
 * @interface ImportV2ApiApiV2ToolsImportImportRunIdUndoPostRequest
 */
export interface ImportV2ApiApiV2ToolsImportImportRunIdUndoPostRequest {
    /**
     * The run.
     * @type {string}
     * @memberof ImportV2ApiApiV2ToolsImportImportRunIdUndoPost
     */
    readonly importRunId: string
}

/**
 * Request parameters for apiV2ToolsImportPost operation in ImportV2Api.
 * @export
 * @interface ImportV2ApiApiV2ToolsImportPostRequest
 */
export interface ImportV2ApiApiV2ToolsImportPostRequest {
    /**
     * The workbook.
     * @type {File}
     * @memberof ImportV2ApiApiV2ToolsImportPost
     */
    readonly file?: File

    /**
     * 
     * @type {string}
     * @memberof ImportV2ApiApiV2ToolsImportPost
     */
    readonly effectiveDate?: string

    /**
     * 
     * @type {boolean}
     * @memberof ImportV2ApiApiV2ToolsImportPost
     */
    readonly addEmployeeIfNotFound?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ImportV2ApiApiV2ToolsImportPost
     */
    readonly onlyUpdateEmptyFields?: boolean

    /**
     * 
     * @type {number}
     * @memberof ImportV2ApiApiV2ToolsImportPost
     */
    readonly companyLaborLevelId?: number
}

/**
 * ImportV2Api - object-oriented interface
 * @export
 * @class ImportV2Api
 * @extends {BaseAPI}
 */
export class ImportV2Api extends BaseAPI {
    /**
     * 
     * @summary The facility\'s imports, newest first.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportV2Api
     */
    public apiV2ToolsImportHistoryGet(options?: AxiosRequestConfig) {
        return ImportV2ApiFp(this.configuration).apiV2ToolsImportHistoryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancels a queued or running import; a running one stops after the row in flight, and the rows it imported are still recalculated.
     * @param {ImportV2ApiApiV2ToolsImportImportRunIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportV2Api
     */
    public apiV2ToolsImportImportRunIdDelete(requestParameters: ImportV2ApiApiV2ToolsImportImportRunIdDeleteRequest, options?: AxiosRequestConfig) {
        return ImportV2ApiFp(this.configuration).apiV2ToolsImportImportRunIdDelete(requestParameters.importRunId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads the file as it was uploaded.
     * @param {ImportV2ApiApiV2ToolsImportImportRunIdFileGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportV2Api
     */
    public apiV2ToolsImportImportRunIdFileGet(requestParameters: ImportV2ApiApiV2ToolsImportImportRunIdFileGetRequest, options?: AxiosRequestConfig) {
        return ImportV2ApiFp(this.configuration).apiV2ToolsImportImportRunIdFileGet(requestParameters.importRunId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The run\'s state and counts, for polling.
     * @param {ImportV2ApiApiV2ToolsImportImportRunIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportV2Api
     */
    public apiV2ToolsImportImportRunIdGet(requestParameters: ImportV2ApiApiV2ToolsImportImportRunIdGetRequest, options?: AxiosRequestConfig) {
        return ImportV2ApiFp(this.configuration).apiV2ToolsImportImportRunIdGet(requestParameters.importRunId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Downloads the run\'s log as CSV, undo results included.
     * @param {ImportV2ApiApiV2ToolsImportImportRunIdLogGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportV2Api
     */
    public apiV2ToolsImportImportRunIdLogGet(requestParameters: ImportV2ApiApiV2ToolsImportImportRunIdLogGetRequest, options?: AxiosRequestConfig) {
        return ImportV2ApiFp(this.configuration).apiV2ToolsImportImportRunIdLogGet(requestParameters.importRunId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary A page of the run\'s log.
     * @param {ImportV2ApiApiV2ToolsImportImportRunIdRowsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportV2Api
     */
    public apiV2ToolsImportImportRunIdRowsGet(requestParameters: ImportV2ApiApiV2ToolsImportImportRunIdRowsGetRequest, options?: AxiosRequestConfig) {
        return ImportV2ApiFp(this.configuration).apiV2ToolsImportImportRunIdRowsGet(requestParameters.importRunId, requestParameters.outcome, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Undoes an import: what it added is deleted (soft delete) and what it changed is put back, row  by row. A row changed since, open on another user\'s screen, or in a pay period the caller may  not edit is left and listed in the log.
     * @param {ImportV2ApiApiV2ToolsImportImportRunIdUndoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportV2Api
     */
    public apiV2ToolsImportImportRunIdUndoPost(requestParameters: ImportV2ApiApiV2ToolsImportImportRunIdUndoPostRequest, options?: AxiosRequestConfig) {
        return ImportV2ApiFp(this.configuration).apiV2ToolsImportImportRunIdUndoPost(requestParameters.importRunId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads a workbook (.xlsx, .xls or .csv) and queues its import. Each sheet is imported by the  type its file or sheet name selects, as in LegacyApp.
     * @param {ImportV2ApiApiV2ToolsImportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportV2Api
     */
    public apiV2ToolsImportPost(requestParameters: ImportV2ApiApiV2ToolsImportPostRequest = {}, options?: AxiosRequestConfig) {
        return ImportV2ApiFp(this.configuration).apiV2ToolsImportPost(requestParameters.file, requestParameters.effectiveDate, requestParameters.addEmployeeIfNotFound, requestParameters.onlyUpdateEmptyFields, requestParameters.companyLaborLevelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Options defaults, the company filter, the run in flight.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportV2Api
     */
    public apiV2ToolsImportSetupGet(options?: AxiosRequestConfig) {
        return ImportV2ApiFp(this.configuration).apiV2ToolsImportSetupGet(options).then((request) => request(this.axios, this.basePath));
    }
}
